export default __webpack_public_path__ + "static/bg2_kpcovid19.jpeg?de5659898d3b";